/* unplugin-vue-components disabled */import script from "./comment.vue?vue&type=script&setup=true&lang=js"
export * from "./comment.vue?vue&type=script&setup=true&lang=js"

import "./comment.vue?vue&type=style&index=0&id=5ccce45a&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ccce45a"]])

export default __exports__